import {AsyncActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/AsyncActDecorator';
import { inversifyContainer} from '@gongxigames/framework/core';
import {DI, ILogic} from '@gongxigames/framework/slot';

export class InitLogicAct extends AsyncActDecorator {
    // TODO remove
    private _logic!: ILogic;

    public async execute(): Promise<void> {
        this._logic ??= inversifyContainer.get<ILogic>(DI.Logic);
        await this._logic.initialize();
        this.emitter.emit('General.Game.LOGIC_INITIALIZED');
    }

    getName(): string {
        return 'InitLogicAct';
    }
}